const alert = {
  show({
    actions = [],
    onDismiss = null,
    text = "",
    t = null,
  }, delay = 100) {
    setTimeout(() => {
      globalThis.$events.$emit("app-bottom-sheet", {
        actions,
        component: "app-alert",
        onDismiss,
        text,
        t,
      });
    }, delay);
  },

  dismiss() {
    globalThis.$events.$emit("app-bottom-sheet", { dismiss: true });
  },
};

globalThis.$alert = alert;

export default {
  install(Vue) {
    Vue.prototype.$alert = alert;
  },
};
